// Build configuration utility
// Determines build-time features based on REACT_APP_ENTRY environment variable

// Detect if we're in a "latest" or "by" build (includes project content)
export const isLatestBuild = () => {
    return process.env.REACT_APP_ENTRY === 'latest' || process.env.REACT_APP_ENTRY === 'by';
};

// Feature flag for project clickability
export const PROJECTS_CLICKABLE = isLatestBuild();

// Helper to get build type for debugging
export const getBuildType = () => {
    return process.env.REACT_APP_ENTRY || 'main';
};
